import React from 'react'
import styled from 'styled-components'
import { Text } from '@thirstycamel/ui'

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  min-width: 0;
`

const TableScroll = styled.div`
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
`

const Table = styled.table`
  width: 100%;
  min-width: 520px;
  border-collapse: collapse;
`

const Th = styled.th`
  text-align: left;
  font-size: 13px;
  color: #cd1f3d;
  padding: 8px 6px;
`

const Td = styled.td`
  padding: 8px 6px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 14px;
`

type Column<T> = {
  header: string
  key: keyof T
  format?: (value: any, row: T) => string
}

type Props<T> = {
  title: string
  columns: Column<T>[]
  rows: T[]
}

const ReportingTableCard = <T extends Record<string, any>>({ title, columns, rows }: Props<T>) => {
  return (
    <Card>
      <Text fontSize="lg" fontWeight="extrabold" color="#cd1f3d" mb={3}>
        {title}
      </Text>
      <TableScroll>
        <Table>
          <thead>
            <tr>
              {columns.map(column => (
                <Th key={String(column.key)}>{column.header}</Th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {columns.map(column => (
                  <Td key={String(column.key)}>
                    {column.format ? column.format(row[column.key], row) : String(row[column.key])}
                  </Td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </TableScroll>
    </Card>
  )
}

export default ReportingTableCard
